module.exports = __webpack_public_path__ + "img/myanmar.32dda71c.png";